import React, {Fragment, Component} from 'react'
import { connect } from 'react-redux'
import moment from 'moment/moment'

import BkFlowRoomCardNightlyRates from '../../BkFlowRoomCardNightlyRates'
import BkFlowPartnersBenefitsBanner from '../../../../partners/BkFlowPartnersBenefitsBanner'
import BkFlowRoomCardTaxesFees from '../../BkFlowRoomCardTaxesFees'

import _ from 'lodash'
import yn from 'yn'

import getCurrencySymbol from '../../../../../utilities/currency/getCurrencySymbol'
import formatPrice from '../../../../../utilities/currency/formatPrice'

import informationIcon from '../../../../../assets/icons/information-icon.svg'
import Modal from 'react-modal'
import dateFormats from '../../../../../utilities/dates/dateFormats'

class BkFlowRoomCardDefaultRateToggle extends Component {
	constructor(props) {
		super(props)
		this.state = {
			rateDetailsExpanded: false
		}
	}

	toggleRateDetails() {
		this.setState({
			rateDetailsExpanded: !this.state.rateDetailsExpanded
		})
	}

	render() {
		const {
			activeCurrencyData,
			availabilityData,
			configData,
			currentRateCode,
			displayedPriceFrequency,
			genericRateLabel,
			hotelLabels,
			isLoyaltyRate,
			ratePlanData,
			roomGroup,
			roomRateData,
			setSelectedRoom,
			totalNights,
			urlData,
		} = this.props

		const addTotals = (a, b) => a + b

		let activeHotelCode = null
		let matchedProperty = null
		let propertyClassType = 20

		// Get hotel code from avail response
		if (!_.isEmpty(urlData) && urlData.hotelCode) {
			activeHotelCode = urlData.hotelCode
		}

		if (!_.isEmpty(configData)) {
			const configProperties = configData.hotel.options.properties

			// Match activeHotelCode to config properties array
			matchedProperty = configProperties.find(function (property) {
				return property.hotelCode === String(activeHotelCode)
			})

			if (matchedProperty && matchedProperty.propertyClassType) {
				propertyClassType = Number(matchedProperty.propertyClassType)
			}
		}

		let roomRateDiscountData = []
		let roomRatePrice = null
		let rateBeforeDiscount = null
		let rateCancelCurrencyCode = null
		let rateCancelCurrencySymbol = null
		let rateCancelDeadline = null
		let rateCancelFee = null
		let rateCurrencyCode = 'USD'
		let rateCurrencySymbol = getCurrencySymbol(rateCurrencyCode)
		let ratePlanCancelPolicy = null
		let ratePlanName = null
		let renderNightlyRates = []
		let roomRatePlanId = null
		let partnerRateData = null
		let destinationFeeDisclaimer = null

		if (
			roomRateData.rates &&
			_.get(roomRateData.rates, '[0].total.currencyCode')
		) {
			rateCurrencyCode = roomRateData.rates[0].total.currencyCode
			rateCurrencySymbol = getCurrencySymbol(rateCurrencyCode)
		}

		// Calculated exchange format for daily price symbol and code
		if (
			yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
			activeCurrencyData &&
			activeCurrencyData.exchangeRate &&
			activeCurrencyData.currencyCode
		) {
			rateCurrencyCode = activeCurrencyData.currencyCode

			if (activeCurrencyData.currencySymbol) {
				rateCurrencySymbol = activeCurrencyData.currencySymbol
			} else {
				rateCurrencySymbol = getCurrencySymbol(activeCurrencyData.currencyCode)
			}
		}

		// Set rate plan name
		if (
			ratePlanData &&
			ratePlanData.ratePlanName
		) {
			ratePlanName = ratePlanData.ratePlanName
		}

		// Set rate plan cancel fee and deadline
		if (
			roomRateData &&
			roomRateData.rates &&
			_.get(roomRateData.rates, '[0].cancelPolicies') &&
			!_.isEmpty(roomRateData.rates[0].cancelPolicies)
		) {
			const cancellationRules = roomRateData.rates[0].cancelPolicies[0]

			if (
				cancellationRules.deadline &&
				cancellationRules.deadline.absoluteDeadline
			) {
				rateCancelDeadline = moment(new Date(cancellationRules.deadline.absoluteDeadline)).format(dateFormats.roomRateCancellationDeadline)
			}

			if (
				cancellationRules.penaltyDescription &&
				cancellationRules.penaltyDescription.text
			) {
				ratePlanCancelPolicy = cancellationRules.penaltyDescription.text
			}

			if (cancellationRules.amountPercent) {
				if (cancellationRules.amountPercent.amount) {
					rateCancelFee = formatPrice(cancellationRules.amountPercent.amount)
				}

				if (cancellationRules.amountPercent.currencyCode) {
					rateCancelCurrencyCode = formatPrice(cancellationRules.amountPercent.currencyCode)
					rateCancelCurrencySymbol = getCurrencySymbol(rateCancelCurrencyCode)
				}
			}
		}

		// enable front end exchange rate calculations
		if (
			yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
			activeCurrencyData &&
			activeCurrencyData.exchangeRate
		) {
			if (displayedPriceFrequency === 'per stay') {
				roomRatePrice = roomRateData.rates[0].total.amountBeforeTax * activeCurrencyData.exchangeRate
			} else {
				roomRatePrice = roomRateData.rates[0].total.amountBeforeTax / totalNights * activeCurrencyData.exchangeRate
			}
		} else if (displayedPriceFrequency === 'per stay') {
			// Set average rate to nightly or total based on env
			roomRatePrice = roomRateData.rates[0].total.amountBeforeTax
		} else {
			roomRatePrice = roomRateData.rates[0].total.amountBeforeTax / totalNights
		}

		const currentRoomDiscountBeforeTax = _.get(roomRateData, 'rates[0].discount.amountBeforeTax', 0)

		// Combine discount line items into a single total
		if (
			roomRateData.rates &&
			_.get(roomRateData.rates, '[0].discount') &&
			!_.isEmpty(roomRateData.rates[0].discount) &&
			currentRoomDiscountBeforeTax &&
			Number(currentRoomDiscountBeforeTax) > 0
		) {
			roomRateDiscountData.push(roomRateData.rates[0].discount.amountBeforeTax)
		}

		// Calculate rate before discount
		if (
			roomRatePrice > 0 &&
			!_.isEmpty(roomRateDiscountData)
		) {
			// Default rate before discount (average nightly rate)
			rateBeforeDiscount = roomRateDiscountData.reduce(addTotals, 0) + roomRatePrice

			// Calculate rate by total amount before tax
			if (displayedPriceFrequency === 'per stay') {
				rateBeforeDiscount = roomRateDiscountData.reduce(addTotals, 0) + roomRatePrice

				// Enable front-end FOREX conversion on total amount
				if (
					yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
					activeCurrencyData &&
					activeCurrencyData.exchangeRate
				) {
					rateBeforeDiscount = roomRateDiscountData.reduce(addTotals, 0) + roomRatePrice * activeCurrencyData.exchangeRate
				}
			} else if (
				yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
				activeCurrencyData &&
				activeCurrencyData.exchangeRate
			) {
				// Enable front-end FOREX conversion on average nightly amount
				rateBeforeDiscount = roomRateDiscountData.reduce(addTotals, 0) + roomRatePrice / totalNights * activeCurrencyData.exchangeRate
			}
		}

		if (
			roomRateData &&
			roomRateData.viewExtensions &&
			!_.isEmpty(roomRateData.viewExtensions.nightlyRates)
		) {
			renderNightlyRates = (
				<BkFlowRoomCardNightlyRates
					configData={configData}
					activeCurrencyData={activeCurrencyData}
					roomRateData={roomRateData}
					rateCurrencyCode={rateCurrencyCode}
					rateCurrencySymbol={rateCurrencySymbol}
				/>
			)
		}


		// Render Partners Branding
		if (
			yn(process.env.REACT_APP_COMPONENT_PARTNERS_RATE_BRANDING) &&
			roomRateData &&
			roomRateData.viewExtensions &&
			roomRateData.viewExtensions.ratePlanId
		) {
			roomRatePlanId = roomRateData.viewExtensions.ratePlanId

			if (String(urlData.promoCode) === String(roomRatePlanId)) {
				if (
					availabilityData &&
					_.get(availabilityData, '[0][0].basicPropertyInfo.viewExtensions.partners')
				) {
					const currentPartnersData = availabilityData[0][0].basicPropertyInfo.viewExtensions.partners.filter(function(partner) {
						return partner.ratePlanId === roomRatePlanId
					})

					partnerRateData = currentPartnersData[0]
				}
			}
		}

		// Destination fee disclaimer shown in info windows on room cards
		if (
			availabilityData &&
			availabilityData[0] &&
			_.get(availabilityData[0], '[0].viewExtensions.destinationFee')
		) {
			destinationFeeDisclaimer = availabilityData[0][0].viewExtensions.destinationFee
		}

		return (
			<div
				className={`bk-flow-room__price-col col-xs-12${roomRateData.ratePlanCode === currentRateCode ? ' active-rate' : ''}${isLoyaltyRate ? ' loyalty-rate' : ''}`}
				id={'bk-flow-room__rate-' + roomGroup + '-' + roomRateData.roomTypeCode + '-' + roomRateData.ratePlanCode}
				onClick={() => setSelectedRoom('bk-flow-room__rate-' + roomGroup + '-' + roomRateData.roomTypeCode + '-' + roomRateData.ratePlanCode, roomRateData.roomTypeCode, roomRateData.ratePlanCode)}
				tabIndex={0}
			>
				<div className="bk-flow-room__price-content row start-xs">
					<div className="bk-flow-room__price-checkbox">
						<div className="custom-icon--checkbox"></div>
					</div>

					<div className="bk-flow-room__price-details">
						<p className="bk-flow-room__price-value">
							<span className="price u-font-bold">
								{ rateCurrencySymbol }
								{ formatPrice(roomRatePrice) }
							</span>

							<span className="price-type u-font-bold u-text-titlecase">
								&nbsp;{yn(process.env.REACT_APP_COMPONENT_ROOM_CURRENCY_CODES) ? rateCurrencyCode : null}
								{ yn(process.env.REACT_APP_COMPONENT_PRICE_AVG_LABELS) ?
									hotelLabels && hotelLabels.avg ? ' ' + hotelLabels.avg : ' Avg'
									:
									null
								}
								{yn(process.env.REACT_APP_COMPONENT_PRICE_NIGHT_LABELS) && `/${hotelLabels ? hotelLabels.night : 'Night'}`}
							</span>

							{ ratePlanData &&
								rateBeforeDiscount &&
								rateBeforeDiscount > 0 &&
								<span className="u-txt-strike">
									{rateCurrencySymbol}
									{formatPrice(rateBeforeDiscount)}&nbsp;
									{rateCurrencyCode}
								</span>
							}
						</p>

						{ ratePlanName &&
							<p className="bk-flow-room__price-title u-remove-margin">
								{ yn(process.env.REACT_APP_COMPONENT_ENABLE_GENERIC_LABELS) &&
									genericRateLabel &&
									<span className="u-font-bold">{genericRateLabel} - </span>
								}
								{ratePlanName}
							</p>
						}
					</div>

					<div
						onClick={() => this.toggleRateDetails()}
						className="bk-flow-room__price-info"
						tabIndex={0}
					>
						<img src={informationIcon} alt="More Information"/>
					</div>

					<Modal
						className={{
							base: 'bk-flow-room__price-details-modal u-modal u-modal--sm',
							afterOpen: 'u-modal--visible',
							beforeClose: 'u-modal--close',
							ariaHideApp: false
						}}
						overlayClassName={{
							base: 'u-fade',
							afterOpen: 'u-fade--visible',
							beforeClose: 'u-fade--visible'
						}}
						isOpen={ this.state.rateDetailsExpanded }
						onRequestClose={ () => this.toggleRateDetails() }
						contentLabel="Room Rate Details Modal"
						shouldCloseOnOverlayClick={ true }
						ariaHideApp={ false }
					>
						{ratePlanName &&
							<div className="u-modal__header">
								<h5>{ ratePlanName }</h5>
								<div
									className="u-modal__close u-font-small u-font-bold"
									onClick={ () => this.toggleRateDetails() }
								>
									{ hotelLabels.close ? hotelLabels.close : 'Close' }
									<i className="material-icons">close</i>
								</div>
							</div>
						}

						<div className="u-modal__body">
							{ratePlanCancelPolicy &&
								<Fragment>
									<h6 className="u-font-bold">
										{hotelLabels && hotelLabels.cancellationPolicy ? hotelLabels.cancellationPolicy : 'Cancellation Policy'}
									</h6>

									<p>{ratePlanCancelPolicy}</p>
								</Fragment>
							}

							{ratePlanCancelPolicy && rateCancelDeadline &&
								<div className="cancel-deadline">
									<h6 className="u-font-bold">{hotelLabels && hotelLabels.cancellationDeadline ? hotelLabels.cancellationDeadline : 'Cancellation Deadline'}</h6>

									{ rateCancelDeadline && rateCancelFee ?
										<p>
											{ hotelLabels && hotelLabels.cancel ? hotelLabels.cancellationChange + ' ' : 'Cancellation charge of '}
											{ rateCancelCurrencySymbol }{rateCancelFee }{ rateCancelCurrencyCode }{ ' until ' }{ rateCancelDeadline }
										</p>
									: rateCancelDeadline ?
										<p>{ hotelLabels && hotelLabels.cancelFreeCharge ? hotelLabels.cancelFreeCharge + ' ' : 'Cancel free of charge until '}  { rateCancelDeadline }</p>
									:
										null
									}
								</div>
							}

							{ yn(process.env.REACT_APP_COMPONENT_PARTNERS_RATE_DETAILS) && partnerRateData && <BkFlowPartnersBenefitsBanner disableLogo={true} /> }

							{ renderNightlyRates }

							{ yn(process.env.REACT_APP_COMPONENT_ENABLE_DETAILED_FEES_AND_TAXES) &&
								<BkFlowRoomCardTaxesFees
									hotelLabels={hotelLabels}
									roomRateData={roomRateData}
									activeCurrencyData={activeCurrencyData}
									rateCurrencyCode={rateCurrencyCode}
									rateCurrencySymbol={rateCurrencySymbol}
								/>
							}

							{ destinationFeeDisclaimer &&
								<Fragment>
									<h6 className="u-font-bold">
										{ propertyClassType === 30 ?
											hotelLabels.resortFee ? hotelLabels.resortFee : 'Resort Fee'
										: propertyClassType === 47 ?
											hotelLabels.amenityFee ? hotelLabels.amenityFee : 'Amenity Fee'
										: propertyClassType === 26 ?
											hotelLabels.sustainabilityFee ? hotelLabels.sustainabilityFee : 'Sustainability Fee'
										:
											hotelLabels.destinationFee ? hotelLabels.destinationFee : 'Destination Fee'
										}
									</h6>
									<p>{ destinationFeeDisclaimer }</p>
								</Fragment>
							}

							<h6 className="u-font-bold">
								{ hotelLabels && hotelLabels.total ? hotelLabels.total : 'Total'}
							</h6>

							{ roomRateData && roomRateData.rates && _.get(roomRateData.rates, '[0].total.amountAfterTax') &&
								<p className="u-remove-margin">
									<span className="u-font-bold">
										{ rateCurrencySymbol }
										{ yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
										activeCurrencyData &&
										activeCurrencyData.exchangeRate ?
											formatPrice(roomRateData.rates[0].total.amountAfterTax * activeCurrencyData.exchangeRate, 2)
											:
											formatPrice(roomRateData.rates[0].total.amountAfterTax, 2)
										}
										&nbsp;
									</span>
									{rateCurrencyCode && rateCurrencyCode}
								</p>
							}
						</div>
					</Modal>
				</div>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		configData: state.configData.configuration,
		availabilityData: state.availabilityData.availability,
		urlData: state.availabilityData.urlData,
	}
}

export default connect(mapStateToProps, null)(BkFlowRoomCardDefaultRateToggle)


// WEBPACK FOOTER //
// ./src/components/room/elements/default/configured/BkFlowRoomCardDefaultRateToggle.js